import { Role } from '@/Enums/Users/Role.enum';
import { IFilterFormData } from '@/Interfaces/PdfBuilder/FilterFormData.interface';
import { downloadPdfReport, generatePdf } from '@/store/api/pdfBuilder.api';
import { useAppSelector } from '@/store/hooks';
import { selectRibeyeAllClients, selectRibeyeAllWhitelabels } from '@/store/selectors/sharedApi.selectors';
import { CustomReportDownloadFunction } from '@/types/ReportBuilder/GridFunction.types';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

interface IUsePdfReportActionsParams {
  meRole: Role;
  onReportGenerated: () => void;
  onFinally: () => void;
}

export const usePdfReportActions = ({ meRole, onReportGenerated, onFinally }: IUsePdfReportActionsParams) => {
  const [loadingReportRun, setLoadingReportRun] = useState<boolean>(false);

  const clients = useAppSelector(selectRibeyeAllClients);
  const whitelabels = useAppSelector(selectRibeyeAllWhitelabels);

  const onSubmitFilters = useCallback(
    async (data: IFilterFormData) => {
      setLoadingReportRun(true);
      try {
        await generatePdf(data, meRole, clients, whitelabels);
        onReportGenerated();
      } catch (_e) {
        toast.error('Something went wrong during PDF report generation');
      }
      setLoadingReportRun(false);
      onFinally();
    },
    [meRole, clients, whitelabels, onReportGenerated, onFinally],
  );

  const onReportDownload = useCallback<CustomReportDownloadFunction>(id => downloadPdfReport(id), []);

  return { onSubmitFilters, onReportDownload, loadingReportRun };
};
